import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { type NextBestAction as NextBestActionType } from '@post-office/confluence-next-best-action';
import { type FunctionComponent, type ReactNode } from 'react';

import { NextBestActionPressable } from '../next-best-action-button';
import { useActionMessageClicked } from '../next-best-action-button/use-action-message-clicked';

const nextBestActionButtonStyles = xcss({
	display: 'flex',
	width: '120px',
	paddingLeft: '0',
	paddingRight: '0',
	whiteSpace: 'nowrap',
	color: 'color.link',
	backgroundColor: 'color.background.accent.blue.subtlest',
	':hover': {
		textDecoration: 'underline',
	},
});

export const NextBestAction: FunctionComponent<{
	ctaMessage: ReactNode;
	onCTAClick: (e: React.MouseEvent<HTMLElement>) => void;
	nextBestActionType: NextBestActionType;
}> = ({ ctaMessage, onCTAClick, nextBestActionType }) => {
	const interactionIdentifier = `next-best-action-message-${nextBestActionType}`;

	const { handleClick } = useActionMessageClicked(onCTAClick, interactionIdentifier);

	return (
		<NextBestActionPressable
			ctaText={ctaMessage}
			onCTAClick={handleClick}
			pressableStyle={nextBestActionButtonStyles}
		/>
	);
};
